enum Target2SkuRoutes {
  DefaultList = '/new-targets-sku',
  TerritoryList = '/new-targets-sku/territory',
  FarmerList = '/new-targets-sku/farmer',
  RetailerList = '/new-targets-sku/retailer',
  CropList = '/new-targets-sku/crop',
  PedigreedList = '/new-targets-sku/pedigreed',
  PedigreedGrowerList = '/new-targets-sku/pedigreed-grower',
}

export default Target2SkuRoutes
